import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ $disabled: boolean }>(
  ({ theme, $disabled }) => css`
    padding: 0;
    display: flex;
    align-items: center;
    gap: ${theme.sz.s2};
    ${theme.typography.paragraph.m};
    cursor: pointer;
    color: ${$disabled ? theme.co.secondary50 : theme.co.secondary0};
  `,
);

export const ButtonWrapper = styled.button<{
  $disabled: boolean;
  $inverseColors: boolean;
  $pressed: boolean;
  $textInside: boolean;
}>(
  ({ theme, $disabled, $inverseColors, $pressed, $textInside }) => css`
    cursor: pointer;

    border-radius: 50%;
    border: none;
    width: ${theme.sz.s8};
    height: ${theme.sz.s8};
    padding: 0;

    background-color: ${theme.co.neutral98};
    color: ${$disabled ? theme.co.secondary50 : theme.co.secondary0};
    text-align: -webkit-center;

    &:hover {
      background-color: ${theme.co.neutral95};
    }

    ${
      $inverseColors &&
      css`
        background-color: ${$disabled ? theme.co.neutral98 : theme.co.primary20};

        &:hover {
          background-color: ${$disabled ? theme.co.neutral95 : theme.co.primary40};
        }
      `
    }

    ${
      $pressed &&
      css`
        background-color: ${theme.co.primary90};
        border: ${theme.bo.thinWidth} solid ${theme.co.primary20};

        &:hover {
          background-color: ${theme.co.primary90};
        }
      `
    };

    ${
      $textInside &&
      css`
        display: flex;
        align-items: center;
        width: auto;
        padding: ${theme.sz.s2};
        gap: ${theme.sz.s2};
        border-radius: ${theme.bo.medium};
        border: ${theme.bo.thinWidth} solid ${$pressed ? theme.co.primary20 : theme.co.neutral95};
        ${theme.typography.paragraph.base};
      `
    };

    & svg {
      font-size: ${theme.sz.s5};
    }
  `,
);
